const adNormSetsTabConfig = {
  tabsList: [
    {
      key: 'ad',
      label: 'Ad Sets'
    },
    {
      key: 'norm',
      label: 'norms'
    }
  ]
}
export default adNormSetsTabConfig



// WEBPACK FOOTER //
// ./src/app/configuration/Template/config/components/generic/AdNormSetsTab.js